// extracted by mini-css-extract-plugin
export default {"card":"CatalogCard_card__WhGaO","cardImg":"CatalogCard_cardImg__RCmKH"};